import { controlToastState } from "risa-oasis-ui_v2";
import {
  getCmmInputDataForOrder,
  reRunWorkflows,
} from "../../../api/bigQuery/nycbsPharmaOrders";

export const executeRerunFromAsteraOncologySanity = async (
  orderId: string,
  onSuccess?: () => void,
) => {
  try {
    const orderResponse = await getCmmInputDataForOrder(orderId);
    const orderData = orderResponse?.["details"];

    if (!orderData) {
      throw new Error("Failed to fetch order data");
    }

    const drugName =
      orderData?.drug_name?.split(" ")[0] || orderData?.drug_name;

    const payload = {
      drug_name: drugName,
      identifier: orderData?.identifier,
      patient_dob: orderData?.patient_dob,
      is_new_request: false,
      org_id: orderData?.org_id,
    };

    await reRunWorkflows(payload);

    controlToastState("re-run-success-cmm");

    if (onSuccess) {
      onSuccess();
    }
  } catch (error) {
    console.error("Error rerunning from Astera Oncology Sanity:", error);
    controlToastState("re-run-error");
  }
};
